import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GetCreateEngagementInfluencerFoldersAvailability.graphql';
import { Query, QuerygetCreateEngagementInfluencerFoldersAvailabilityArgs } from '../../__generated__/globalTypes';

export const useGetCreateEngagementInfluencerFoldersAvailabilityQuery = (
  options?: QueryHookOptions<Query, QuerygetCreateEngagementInfluencerFoldersAvailabilityArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerygetCreateEngagementInfluencerFoldersAvailabilityArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGetCreateEngagementInfluencerFoldersAvailabilityLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerygetCreateEngagementInfluencerFoldersAvailabilityArgs>
): QueryResult<Query, QuerygetCreateEngagementInfluencerFoldersAvailabilityArgs> & {
  getGetCreateEngagementInfluencerFoldersAvailability: LazyQueryExecFunction<
    Query,
    QuerygetCreateEngagementInfluencerFoldersAvailabilityArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getGetCreateEngagementInfluencerFoldersAvailability, result] = useLazyQuery<
    Query,
    QuerygetCreateEngagementInfluencerFoldersAvailabilityArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getGetCreateEngagementInfluencerFoldersAvailability, ...result };
};

export const useGetCreateEngagementInfluencerFoldersAvailabilityPromiseQuery = () => {
  const client = useApolloClient();

  const getGetCreateEngagementInfluencerFoldersAvailability = useCallback(
    (options?: Omit<QueryOptions<QuerygetCreateEngagementInfluencerFoldersAvailabilityArgs, Query>, 'query'>) =>
      client.query<Query, QuerygetCreateEngagementInfluencerFoldersAvailabilityArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getGetCreateEngagementInfluencerFoldersAvailability };
};
// Suspense Query Hooks
export const useGetCreateEngagementInfluencerFoldersAvailabilitySuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerygetCreateEngagementInfluencerFoldersAvailabilityArgs>
) => {
  const result = useSuspenseQuery<Query, QuerygetCreateEngagementInfluencerFoldersAvailabilityArgs>(QUERY, {
    ...options
  });

  return result;
};
